import React from 'react';
import {Link} from 'react-router';

import {Text} from '@albert-io/atomic';
import {Subject} from './StudentIndependentPractice.types';

interface StudentIndependentPracticeCardProps {
  subject: Subject;
}

export function StudentIndependentPracticeCard({subject}: StudentIndependentPracticeCardProps) {
  const color = `var(--color-background-domain-${subject.curriculumArea.slug})`;

  const to = `/${subject.urlSlug}`;

  return (
    <div
      className='flex w-full cursor-pointer items-center gap-x2 rounded-x1 p-x1 hover:background-primary-hover active:background-primary-pressed'
      onClick={(e) => (e.currentTarget.querySelector('a') as HTMLAnchorElement | null)?.click()}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          (e.currentTarget.querySelector('a') as HTMLAnchorElement | null)?.click();
        }
      }}
      role='button'
      tabIndex={0}
    >
      <div
        className='flex h-x5 w-x5 min-w-x5 items-center justify-center rounded-full'
        style={{backgroundColor: color}}
      >
        {subject.logoUrl ? <img className='h-x3 w-x3' src={subject.logoUrl} alt='' /> : null}
      </div>

      <Text>
        <Link className='text-inherit no-underline' to={to}>
          {subject.name}
        </Link>
      </Text>
    </div>
  );
}
